import React from 'react';
import { MailTemplate } from "../typings";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { MdOutlineMoreVert } from "react-icons/md";
import { useNavigate } from "react-router-dom";

interface Props {
    template: MailTemplate;
}

function TemplateRow(props: Props) {
    const navigate = useNavigate();

    return (
        <div className="box" style={{
            flexDirection: 'row' as 'row',
            padding: '12px 16px',
            width: '100%',
            alignItems: 'center'
        }}>
            <div className="drill-row-item" style={{flex: 1}}>{props.template.id}</div>
            <div className="drill-row-item" style={{flex: 2}}>{props.template.name}</div>
            <div className="drill-row-item" style={{flex: 2}}>{props.template.subject}</div>
            <Menu>
                <MenuButton className="menu-button"><MdOutlineMoreVert size="24px"/></MenuButton>
                <MenuItems
                    className="menu-box"
                    anchor="bottom"
                >
                    <MenuItem>
                        <div className="menu-item" onClick={() => navigate(`/template/${props.template.id}`)}>
                            Edit
                        </div>
                    </MenuItem>
                </MenuItems>
            </Menu>
        </div>
    );
}

export default TemplateRow;
